<template>
    <el-drawer class="nav" direction="ltr" :with-header="false" :visible.sync="drawer" :show-close="false">
        <!-- 内容 -->
        <div class="warpper">
            <!-- 页面导航 -->
            <div class="menu-container">
                <div class="menus-item">
                    <a @click="handleClike('/')">
                        <i class="el-icon-star-off" /> 首页
                    </a>
                </div>
                <div class="menus-item">
                    <a @click="handleClike('/certificate-check')">
                        <i class="el-icon-s-order" /> 证书查询
                    </a>
                </div>

                <div class="menus-item">

                    <a @click="handleClike('/rangeDetail')">
                        <i class="el-icon-menu" /> 检测流程及范围
                    </a>
                </div>
                <div class="menus-item">
                    <a @click="handleClike('/instrument')">
                        <i class="el-icon-discount" /> 检测仪器与方法
                    </a>
                </div>
                <div class="menus-item">
                    <a @click="handleClike('/contact-us')">
                        <i class="el-icon-s-promotion" /> 联系我们
                    </a>
                </div>
                <div class="menus-item">
                    <a @click="handleClike('/about-gic')">
                        <i class="el-icon-chat-dot-square" /> 关于GIC
                    </a>
                </div>
                <!-- <div class="menus-item">
                    <a @click="handleClike('/certificate')">
                        <i class="iconfont icon-pinglun" /> 证书查询
                    </a>
                </div> -->
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { logout } from '@/api'
import { removeToken, getToken } from '@/utils/cookieUtil'
export default {
    data: function () {
        return {
            img: process.env.VUE_APP_IMG_API,
        }
    },
    computed: {
        drawer: {
            set(value) {
                this.$store.state.drawer = value;
            },
            get() {
                return this.$store.state.drawer;
            }
        },
        isLogin() {
            return getToken();
        }
    },

    methods: {
        handleClike(val) {
            this.$store.state.drawer = false
            this.$router.push({ path: val })
        },
        close() {
            this.$store.state.drawer = false;
        },
        openLogin() {
            this.$store.state.loginFlag = true;
        },
        logout() {
            //如果在个人中心则跳回上一页
            if (this.$route.path === "/user") {
                this.$router.go(-1);
            }
            logout().then(res => {
                removeToken()
                location.reload()

                this.$toast.success('注销成功')
            }).catch(err => {
                console.log(err)
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep {
    .el-drawer {
        width: 55% !important;
    }
}

a {
    color: var(--text-color);
}

.nav {
    .warpper {
        font-weight: 700;
        font-size: 1.2rem;
        background-color: var(--background-color);


        .blogger-info {
            padding: 10px 30px 0;
            text-align: center;
            z-index: 99;

            ::v-deep .el-avatar {
                width: 80px;
                height: 80px;
            }
        }

        .blog-info-wrapper {
            display: flex;
            align-items: center;
            padding: 12px 10px 0;

            .blog-info-data {
                flex: 1;
                line-height: 2;
                text-align: center;

                a {
                    text-decoration: none;

                }
            }
        }

        hr {
            border: 2px dashed #d2ebfd;
            margin: 20px 0;
        }

        .menu-container {
            padding: 0 10px 40px;
            overflow: scroll;

            .menus-item {


                a {
                    padding: 6px 30px;
                    display: block;
                    line-height: 2;
                    text-decoration: none;
                }

                i {
                    margin-right: 1rem;
                }
            }
        }
    }
}

@keyframes sidebarItem {
    0% {
        transform: translateX(200px);
    }

    100% {
        transform: translateX(0);
    }
}
</style>
